import HBAvatar from '@honeybook/hbui/dist/components/HBAvatar/HBAvatar';
import HBTooltip from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';
import React from 'react';
import styled from 'styled-components';
import { getMemberInitials } from '~/common/user.utils';
import { IEnrichedSharedMember } from '~/types/server.types';

const MemberAvatarList = ({
    sharedMembers
}: {
    sharedMembers: IEnrichedSharedMember[];
}) => {
    if (!sharedMembers) {
        return <></>;
    }
    const memberAvatarList = sharedMembers.map(
        ({ _id, full_name, profile_image_url }) => {
            const Avatar = (
                <MiniAvatar
                    userInitials={getMemberInitials(full_name)}
                    profileImageUrl={profile_image_url}
                />
            );
            return (
                <HBTooltip key={_id} placement="top" target={Avatar}>
                    {full_name}
                </HBTooltip>
            );
        }
    );

    return (
        <SessionConfigAvatarContainer>
            {memberAvatarList}
        </SessionConfigAvatarContainer>
    );
};

export default MemberAvatarList;

// -------------------------------- Styles -------------------------------- //
const SessionConfigAvatarContainer = styled.div`
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

const MiniAvatar = styled(HBAvatar)`
    min-width: auto;
    width: 24px;
    height: 24px;
    span {
        font-size: 14px;
    }
`;
